import React from "react";
import EAPageHeader from "../shared/EAPageHeader";
import "./CustomOffer.scss";
import useCustomOffer from "./hooks/useCustomOffer";
import { useTranslation } from "react-i18next";
import EAAlert from "../shared/EAAlert";
import { ProductKinds, SaleStep } from "../../store/stepSaleConfig/stepSaleConfigReducer";
import PassModule from "./OfferModules/PassModule";
import EventModule from "./OfferModules/EventModule";
import CalendarSaleModule from "./OfferModules/CalendarSaleModule";
import EAPageMessage from "../shared/EAPageMessage";
import ShapeColorAssortGroupModule from "./OfferModules/ShapeColorAssortGroupModule";

const CustomOffer: React.FC = () => {
  const { t } = useTranslation();
  const { customOffer } = useCustomOffer();

  const getModuleByKind = (saleStep: SaleStep) => {
    switch (saleStep.kind) {
      case ProductKinds.Pass:
        return <PassModule saleStep={saleStep} />;
      case ProductKinds.Event:
        return <EventModule saleStep={saleStep} />;
      case ProductKinds.CalendarSale:
        return <CalendarSaleModule saleStep={saleStep} />;
      case ProductKinds.Shape:
      case ProductKinds.Color:
      case ProductKinds.AssortGroup:
        return <ShapeColorAssortGroupModule saleStep={saleStep} />;
    }
  };

  if (!customOffer) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  } else {
    return (
      <>
        <EAPageHeader title={t(customOffer.stepName)} />
        <EAPageMessage message={t(customOffer.stepDescription)} />

        <div className="offer-products-list">
          {customOffer.saleSteps
            .sort((a, b) => a.order - b.order)
            .map((step, index) => (
              <div key={index}>{getModuleByKind(step)}</div>
            ))}
        </div>
      </>
    );
  }
};

export default CustomOffer;
